const SvgSoftware4 = (props) => (
  <>
    <path d="M0 0v96h96V0H0Zm48 60c-6.63 0-12-5.37-12-12s5.37-12 12-12 12 5.37 12 12-5.37 12-12 12Z" fill={props.p40} />
  </>
);

export default SvgSoftware4;
